import EmptyListIcon from './empty';
import DollarIcon from './dollar';
import BolivarIcon from './bolivar';
import InfoIcon from './info';
import ApprovedIcon from './approved';
import RejectedIcon from './rejected';
import WaitingIcon from './waiting';
import CalendarIcon from './calendar';
import DeleteIcon from './delete';
import AppendIcon from './append';
import AttachmentIcon from './attachment';
import AccountIcon from './account';
import BalanceIcon from './balance';
import CalculatorIcon from './calculator';
import FaqIcon from './faq';
import HistoryIcon from './history';
import LogoutIcon from './logout';
import PaymentsIcon from './payments';
import BalanceSummaryIcon from './balance-summary';
import ProfileIcon from './profile';
import NotificationsIcon from './notifications';
import SuccessIcon from './success';
import CompanyIcon from './company';
import CustomerIcon from './customer';
import ClientsIcon from './clients';
import CallCenterOffIcon from './call-center-off';
import CallCenterOnIcon from './call-center-on';
import CallPhoneIcon from './call-phone';
import WhatsappIcon from './whatsapp';
import MessageIcon from './message';
import CopyIcon from './copy';
import FileAttachmentIcon from './file-attachment';
import FileUploadIcon from './file-upload';
import EyeOffIcon from './eye-off';
import EyeOnIcon from './eye-on';
import FilterCircleIcon from './filter-circle';
import FilterCircleFilledIcon from './filter-circle-filled';
import RemoveFilterCircleIcon from './remove-filter-circle';
import SearchCircleIcon from './search-circle';
import TruckIcon from './truck';
import FactoryIcon from './factory';
import ScheduleIcon from './schedule';
import ArrowLeftIcon from './arrow-left/ArrowLeftIcon';
import ArrowRightIcon from './arrow-right/ArrowRightIcon';
import LocalizationOffIcon from './localization-off';
import LocalizationOnIcon from './localization-on';
import SynchronizationIcon from './synchronization';
import PaymentOnLineIcon from './pay-on-line';

export {
  EyeOnIcon,
  EyeOffIcon,
  FileUploadIcon,
  FileAttachmentIcon,
  CopyIcon,
  MessageIcon,
  CallCenterOffIcon,
  CallCenterOnIcon,
  CallPhoneIcon,
  WhatsappIcon,
  ApprovedIcon,
  EmptyListIcon,
  BolivarIcon,
  DollarIcon,
  InfoIcon,
  RejectedIcon,
  WaitingIcon,
  CalendarIcon,
  DeleteIcon,
  AppendIcon,
  AttachmentIcon,
  AccountIcon,
  BalanceIcon,
  CalculatorIcon,
  FaqIcon,
  HistoryIcon,
  LogoutIcon,
  PaymentsIcon,
  BalanceSummaryIcon,
  ProfileIcon,
  NotificationsIcon,
  SuccessIcon,
  CompanyIcon,
  CustomerIcon,
  ClientsIcon,
  FilterCircleIcon,
  FilterCircleFilledIcon,
  RemoveFilterCircleIcon,
  SearchCircleIcon,
  TruckIcon,
  FactoryIcon,
  ScheduleIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  LocalizationOffIcon,
  LocalizationOnIcon,
  SynchronizationIcon,
  PaymentOnLineIcon,
};
